import React from 'react'
import PropTypes from 'prop-types'

import get from 'lodash/get'
import noop from 'lodash/noop'

import { useBaseTheme } from 'Hooks'

import {
  Container,
  ImageBg,
  OverlayBg,
  TitleHolder,
  Title,
  TitleBg,
  Wrapper,
} from './styles'

const Category = ({ category, circleBorder, roundedBorder, onCategory }) => {
  const { secondaryColor, secondaryTextColor } = useBaseTheme()

  const renderSquare = () => {
    return (
      <Wrapper onClick={onCategory(category)}>
        <Container
          bgurl={get(category, 'image_url')}
          hovercolor={secondaryTextColor}
          roundedborder={roundedBorder}
        >
          <ImageBg src={get(category, 'image_url')} />
          <OverlayBg />
          <TitleHolder position="absolute">
            <Title className="category-title">
              {get(category, 'bucket_name')}
            </Title>
            <TitleBg color={secondaryColor} />
          </TitleHolder>
        </Container>
      </Wrapper>
    )
  }

  const renderCircular = () => {
    return (
      <Wrapper onClick={onCategory(category)}>
        <Container
          bgurl={get(category, 'image_url')}
          circleborder={circleBorder}
          hovercolor={secondaryTextColor}
          roundedborder={roundedBorder}
        >
          <ImageBg src={get(category, 'image_url')} />
          <OverlayBg />
        </Container>
        <TitleHolder align="center" customheight={60}>
          <Title className="category-title" color={secondaryColor}>
            {get(category, 'bucket_name')}
          </Title>
        </TitleHolder>
      </Wrapper>
    )
  }

  return circleBorder ? renderCircular() : renderSquare()
}

Category.defaultProps = {
  category: {},
  circleBorder: 0,
  roundedBorder: 0,
  onCategory: noop,
}

Category.propTypes = {
  category: PropTypes.object,
  circleBorder: PropTypes.number,
  roundedBorder: PropTypes.number,
  onCategory: PropTypes.func,
}

export default Category
